<template>
  <div
    class="bg-secondary-50 flex max-w-5xl flex-col gap-2 rounded-md p-3 shadow-md"
  >
    <div class="text-bold text-2xl">
      <slot name="title" />
    </div>
    <div>
      <slot name="description" />
    </div>
    <div class="mt-4">
      <slot name="cta" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
